import { Subject } from 'rxjs';

export let unauthorisedEventService: UnauthorisedEventService;

export class UnauthorisedEventService {
  unauthorisedErrorObs = new Subject<boolean>();

  constructor() {
    unauthorisedEventService = this;
  }

}
